import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "mt-4" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-center mt-5" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Configuration",
          text: "Edit Configuration"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_form_field, {
          type: "select-string",
          labelKey: "Country Group",
          labelValue: "Country Group",
          placeholderKey: "Country Group",
          placeholderValue: "Country Group",
          list: _ctx.groups,
          modelValue: _ctx.localModel.group,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.group) = $event))
        }, null, 8, ["list", "modelValue"]),
        _createVNode(_component_form_field, {
          type: "text",
          labelKey: "Country",
          labelValue: "Country",
          placeholderKey: "Country",
          placeholderValue: "Country",
          modelValue: _ctx.localModel.country,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.country) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_form_field, {
          type: "text",
          labelKey: "Country Acronym",
          labelValue: "Country Acronym",
          placeholderKey: "Country Acronym",
          placeholderValue: "Country Acronym",
          modelValue: _ctx.localModel.countryShort,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.countryShort) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_form_field, {
            type: "select-string",
            labelKey: "Risk Description",
            labelValue: "Risk Description",
            placeholderKey: "Risk Description",
            placeholderValue: "Risk Description",
            list: _ctx.riskTypes,
            modelValue: _ctx.localModel.risk.key,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.risk.key) = $event)),
            class: "w-100"
          }, null, 8, ["list", "modelValue"]),
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Risk Value",
            labelValue: "Risk Value",
            placeholderKey: "Risk Value",
            placeholderValue: "Risk Value",
            modelValue: _ctx.localModel.risk.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localModel.risk.value) = $event)),
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Emission",
            labelValue: "Emission",
            placeholderKey: "Emission",
            placeholderValue: "Emission",
            modelValue: _ctx.newValuePerYear.kgcO2PerKWH,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newValuePerYear.kgcO2PerKWH) = $event)),
            class: "w-100"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_form_field, {
            type: "number",
            step: "1",
            labelKey: "Year",
            labelValue: "Year",
            placeholderKey: "Year",
            placeholderValue: "Year",
            modelValue: _ctx.newValuePerYear.year,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newValuePerYear.year) = $event)),
            class: "w-100"
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "btn btn-tertiary ms-1",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addNewValue()))
          }, "+")
        ]),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localModel.valuesPerYear, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex align-items-center",
            key: index
          }, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Emission",
              labelValue: "Emission",
              placeholderKey: "Emission",
              placeholderValue: "Emission",
              modelValue: item.kgcO2PerKWH,
              "onUpdate:modelValue": ($event: any) => ((item.kgcO2PerKWH) = $event),
              class: "w-100"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_form_field, {
              type: "number",
              step: "1",
              labelKey: "Year",
              labelValue: "Year",
              placeholderKey: "Year",
              placeholderValue: "Year",
              modelValue: item.year,
              "onUpdate:modelValue": ($event: any) => ((item.year) = $event),
              class: "w-100"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("button", {
              class: "btn btn-danger ms-1",
              onClick: ($event: any) => (_ctx.removeOldValue(index))
            }, "-", 8, _hoisted_11)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.canSave,
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          (!_ctx.localModel.identifier)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Create",
                  text: "Create"
                })
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Edit",
                  text: "Edit"
                })
              ]))
        ], 8, _hoisted_13)
      ])
    ])
  ]))
}